module.exports = __webpack_public_path__ + "img/plac2.47da523d.jpg";